import { styled } from 'styled-components'

export const Box = styled.div`
  margin-top: 8px;
  display: 'flex',
  flex-direction: 'column',
  align-items: 'center'
`

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgb(247, 244, 244);
`

export const Body = styled.div`
  width: 300px;
  background-color: #333333;
  border-radius: 10px;
  flex-direction: column;
  text-align: center;
  padding: 20px;
  margin-top: 200px;
  box-shadow: 3px 4px 6px 4px #bfbfbf;

  display: flex;
  align-items: center;
  justify-content: space-around;

  color: #fff;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 20px;
  letter-spacing: 0.28px;
  padding: 40px;
`

export const Title = styled.span`
  font-size: 32px;
  height: fit-content;
`

export const GoogleSignIn = styled.div`
  position: relative;
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  background-color: #fff;

  font-size: 18px;
  border-radius: 5px;
  text-align: center;
  padding: 10px;
  margin: 30px 0 10px 0;

  box-sizing: border-box;

  svg {
    height: 25px;
    width: 25px;
    margin-right: 10px;
  }

  z-index: 1;
`

export const HiddenGoogleAuth = styled.div`
  position: absolute;
  top: 0px;
  opacity: 0;
  z-index: 2;
`

export const ErrMsg = styled.div`
  color: red;
  width: 100%;
  text-align: center;
` 